import { Promotion } from "@datamodel";
import service from "@services";
const PREFIX = '/promotion_codes';

export const list = async (args) => {
    const response = await service.get(`${PREFIX}/`, args);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            promotions: Promotion.parseArray(response.response)
        }
    }
    throw service.error(response);
}

export const subscribe = async ({ place, code }) => {
    const response = await service.post(`${PREFIX}/code/`, { code, place });
    if (response.status === 'ok') {
        return {
            status: 'ok',
            promotion: Promotion.parse(response.response)
        }
    }
    throw service.error(response);
}
